// Gerado por scripts/build-icons.mjs — não editar manualmente.
import { createBankIcon } from "../createBankIcon";

/** Modobank */
export const Modobank = createBankIcon({
  name: "Modobank",
  slug: "modobank",
  compe: null,
  color: "#ffffff",
  viewBox: "0 0 100.03096 100.03096",
  html: "<rect\n     style=\"fill:#ffffff;fill-opacity:1\"\n     id=\"modobank_rect1\"\n     width=\"100.03096\"\n     height=\"100.03096\"\n     x=\"0\"\n     y=\"0\" />\n  <g transform=\"translate(20.9959,20.9073) scale(0.02322)\">\n    <path d=\"M 1821.43,333.81 c -90.41,-45.07 -191.59,-77.11 -303.4,-96.42 l -45.49,-232.73 l -439.15,0 l -49.67,232.45 C 468.99,309.6 173.57,733.78 189.94,1257.46 c -15.95,519.34 285.35,944.36 792.66,1022.58 l 43.66,222.93 l 437.33,0 l 47.44,-222.09 c 283.11,-48.7 530.54,-198.59 667.4,-452.72 c 243.23,-463.65 165.98,-1254.2 -357,-1494.35 Z M 1581.85,1698.15 c -132.67,180.11 -533.76,179.12 -665.86,0 c -148.35,-150.58 -150.31,-731.08 0.98,-881.25 c 133.65,-176.89 532.22,-177.59 665.02,0.98 c 148.63,150.44 149.6,728.28 0,880.41 l -0.14,-0.14 Z\" style=\"fill:#5064ff\" />\n  </g>",
});
